const defaultConfig = {
  // Contentful - Server-side only tokens
  CONTENTFUL_SPACE_ID: process.env.CONTENTFUL_SPACE_ID,
  CONTENTFUL_ACCESS_TOKEN: process.env.CONTENTFUL_ACCESS_TOKEN,
  CONTENTFUL_PREVIEW_TOKEN: process.env.CONTENTFUL_PREVIEW_TOKEN,

  // Google Maps
  GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_MAP_ID: "cfbf351234dbae29",

  // Facebook
  FACEBOOK_PIXEL_ID: "467522431133167",

  // Google Analytics
  GOOGLE_ANALYTICS_UA: "G-DS9QXNXJYW",
  GOOGLE_TAG_MANAGER_ID: "GTM-TSTS2XW",

  // LinkedIn Insights
  LINKEDIN_INSIGHTS_ID: "9771332",

  // Drift chat app.
  DRIFT_APP_ID: "2b9st37kxvsy",

  // Mapbox
  MAPBOX_TOKEN:
    "pk.eyJ1IjoiZXJta3RnIiwiYSI6ImNsMzlpdW5oeDA1emUzZ2xydHBxejk3ZWsifQ.yvaVuxXXN6ZZQSlZFJdpTQ",
  MAPBOX_STYLE: "mapbox://styles/ermktg/cl31nvixp000615mnntu8hd6c",

  // Next.js will attempt to re-generate the page:
  // - When a request comes in
  // - At most once every hour
  // Netlify's floor is 60s (MINIMUM_REVALIDATE_SECONDS); at that value every
  // crawler sweep is entitled to a re-render, which is what drove the Contentful
  // request volume.
  ISR_TIMING: 3600, // 1 hour incremental static regeneration.

  // A 404 from a dynamic route is usually a bad slug, but can also be a transient
  // Contentful failure. Retry soon rather than caching the miss for a full hour.
  NOT_FOUND_TTL: 60,

  // Every non-dynamic page, swept by /api/revalidate on any Contentful publish.
  // Purging costs nothing — a page only re-queries Contentful when next requested —
  // so a blanket sweep is cheaper than a content-type-to-page map, and cannot rot.
  // Add new static pages here.
  REVALIDATE_STATIC_PATHS: [
    "/",
    "/about-us",
    "/brokers",
    "/careers",
    "/contact",
    "/cookie-policy",
    "/copyright",
    "/downloads",
    "/events",
    "/faq",
    "/film-and-photography",
    "/inclusion-and-diversity",
    "/locations",
    "/login",
    "/news",
    "/privacy-policy",
    "/recruitment-fraud",
    "/referral-program",
    "/solutions",
    "/terms"
  ],

  // CONTACT_FORM_ENDPOINT: "/api/contact", // Local form submission
  CONTACT_FORM_ENDPOINT: "https://eastroom.activehosted.com/proc.php", // Remote form submission

  CONTACT_FORM_EMAIL: "danielle@eastroom.com"
};

const config = {
  development: {
    ...defaultConfig,
    DEBUG: true,
    BASE_URL: "https://www.eastroom.com"
  },
  production: { ...defaultConfig, BASE_URL: "https://www.eastroom.com" }
};

// ISR TTL Configuration
// Defines revalidation timing for different content types based on expected update frequency
export const ISR_TTL = {
  // High-frequency updates (5 minutes)
  // Content that changes frequently or needs to be fresh
  HIGH_FREQUENCY: 300,

  // Medium-frequency updates (30 minutes)
  // Content that changes regularly but not constantly
  MEDIUM_FREQUENCY: 1800,

  // Low-frequency updates (1 hour)
  // Content that changes occasionally
  LOW_FREQUENCY: 3600,

  // Static content (6 hours)
  // Content that rarely changes
  STATIC: 21600
};

export default config[process.env.NODE_ENV || "development"];
